import { render } from "./SupplierPage.vue?vue&type=template&id=bbd1b9f4&scoped=true"
import script from "./SupplierPage.vue?vue&type=script&lang=js"
export * from "./SupplierPage.vue?vue&type=script&lang=js"

import "./SupplierPage.vue?vue&type=style&index=0&id=bbd1b9f4&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbd1b9f4"]])

export default __exports__